import type { AircraftSpec, CharterRequest, CrewMember, Mission, SceneryAirport } from "./types";
import { emptyAccount } from "./ledger";
import type { CompanyAccount } from "./types";

/** Collections a desk has before anyone creates a company. No sample rows. */
export function freshDeskData(): {
  fleet: AircraftSpec[];
  scenery: SceneryAirport[];
  inbox: CharterRequest[];
  missions: Mission[];
  crew: CrewMember[];
  account: CompanyAccount;
} {
  return {
    fleet: [],
    scenery: [],
    inbox: [],
    missions: [],
    crew: [],
    account: emptyAccount(),
  };
}
